export default "__VITE_ASSET__pKQS88SE__"